// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dimple-lowcode-configs[data-v-7abc8139]{width:100%;height:100%;overflow:hidden;display:flex;flex-direction:column}.no-data[data-v-7abc8139]{text-align:center;color:#909399;font-size:.677vw}.main[data-v-7abc8139],.no-data[data-v-7abc8139]{padding:1.042vw;flex:1;border-left:1px solid #ddd;border-right:1px solid #ddd}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
